var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_html.js
// module id = 93
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11